import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import _ from "underscore";

import moment from "moment";

import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import Chart from "../../../utils/chart";
import './storeMsgOrderList.scss';

//import images
import {Badge, Button} from "shards-react";

// 알리고 포인트 단가 (1건 = 6.5P)
const ALIGO_UNIT = 6.5;

let model = {
  store: {
    name: '',
    domain: '',
    logo: '',
    platform: '',
    platformId: '',
    pTeamUser_id: ''
  }
}

@inject(({ common }) => ({ setIsShowPopup: common.setIsShowPopup, isShowModal: common.isShowModal, getIsShowPopup: common.getIsShowPopup  }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me, getInAppOrderList: teamUser.getInAppOrderList, getMsgOrderList: teamUser.getMsgOrderList }))
@inject(({ company }) => ({ updateStore:company.updateStore  }))

@observer
class StoreMsgOrderList extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable isLogin = false;
  @observable isLoading = true;

  @observable listParams = {page:1, limit:500};
  @observable boardList = [];

  // 월별 조회
  @observable selectedMonthStr = moment().format('YYYY-MM');
  // 현재 월의 주문 docs (클라이언트 필터 결과)
  @observable monthDocs = [];
  // 발송건(메시지 히스토리) 스토어별 집계 - 전체 기간
  @observable history = {};
  // 통계 위젯 값
  @observable stats = {
    revenue: 0, orderCount: 0, chargeCount: 0
  };

  constructor(props) {
    super(props);
    this.trendChartRef = React.createRef();
    this.init();
  }

  componentDidMount() {
    if(this.boardList && this.boardList.docs) this.renderTrendChart();
  }

  componentWillUnmount() {
    if(this.trendChartInstance) this.trendChartInstance.destroy();
  }

  @action
  init = async () => {
    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store ? this.props.me.store : model.store;
      this.listParams.store_id = this.store._id;
      this.permissions = this.props.me.permissions;

      if(this.teamUser.isSuper && this.listParams.store_id) {
        this.getList();
      }
      else {
        this.isLoading = false;
      }
    }
  };

  // 선택 월의 시작/끝 moment
  monthStart = () => moment(this.selectedMonthStr, 'YYYY-MM').startOf('month');
  monthEnd = () => moment(this.selectedMonthStr, 'YYYY-MM').endOf('month');
  isCurrentMonth = () => this.selectedMonthStr === moment().format('YYYY-MM');

  @action
  changeMonth = (delta) => {
    const next = moment(this.selectedMonthStr, 'YYYY-MM').add(delta, 'month');
    // 미래 월 조회 방지
    if(next.isAfter(moment(), 'month')) return;
    this.selectedMonthStr = next.format('YYYY-MM');
    this.getList();
  };

  @action
  setThisMonth = () => {
    this.selectedMonthStr = moment().format('YYYY-MM');
    this.getList();
  };

  @action
  getList = async () => {
    this.isLoading = true;
    this.listParams.isSuper = true;
    this.listParams.page = 1;
    this.listParams.searchParams = {
      startDate: this.monthStart().format('YYYY-MM-DD'),
      endDate: this.monthEnd().format('YYYY-MM-DD')
    };

    this.boardList = await this.props.getMsgOrderList(this.listParams);

    this.history = (this.boardList && this.boardList.meta && this.boardList.meta.countData)
      ? _.indexBy(this.boardList.meta.countData, "_id")
      : {};

    this.computeStats();
    this.isLoading = false;
    this.renderTrendChart();
  };

  @action
  computeStats = () => {
    const docs = (this.boardList && this.boardList.docs) || [];
    const ym = this.selectedMonthStr;

    // 백엔드 기간 필터가 아직 배포되지 않아도 정확하도록 클라이언트에서 선택 월로 한번 더 필터
    const monthDocs = docs.filter(d => d.createdAt && moment(d.createdAt).format('YYYY-MM') === ym);
    this.monthDocs = monthDocs;

    const success = monthDocs.filter(d => d.paySuccess === 'success');
    const sum = (arr, f) => arr.reduce((acc, d) => acc + (Number(f(d)) || 0), 0);

    this.stats = {
      revenue: sum(success, d => d.orderAmount),
      orderCount: success.length,
      chargeCount: sum(success, d => d.count)
    };
  };

  // 최근 12개월 월별 결제 건수 데이터 (meta.monthlyCounts 우선, 없으면 로드된 docs 로 폴백)
  buildMonthlyData = () => {
    const months = [];
    for(let i = 11; i >= 0; i--) {
      months.push(moment().subtract(i, 'month').format('YYYY-MM'));
    }
    let countMap = {};
    const meta = this.boardList && this.boardList.meta;
    if(meta && meta.monthlyCounts && meta.monthlyCounts.length) {
      meta.monthlyCounts.forEach(m => { countMap[m._id] = m.count; });
    }
    else {
      const docs = (this.boardList && this.boardList.docs) || [];
      docs.forEach(d => {
        if(d.paySuccess === 'success' && d.createdAt) {
          const k = moment(d.createdAt).format('YYYY-MM');
          countMap[k] = (countMap[k] || 0) + 1;
        }
      });
    }
    const labels = months.map(m => moment(m, 'YYYY-MM').format('YY.MM'));
    const data = months.map(m => countMap[m] || 0);
    const selIdx = months.indexOf(this.selectedMonthStr);
    return { labels, data, selIdx };
  };

  renderTrendChart = () => {
    if(!this.trendChartRef || !this.trendChartRef.current) return;
    if(this.trendChartInstance) this.trendChartInstance.destroy();

    const { labels, data, selIdx } = this.buildMonthlyData();
    const accent = 'rgba(74, 108, 247, 1)';

    this.trendChartInstance = new Chart(this.trendChartRef.current, {
      type: 'line',
      data: {
        labels,
        datasets: [{
          label: '결제 건수',
          data,
          fill: 'start',
          backgroundColor: 'rgba(74, 108, 247, 0.08)',
          borderColor: accent,
          borderWidth: 2,
          pointBackgroundColor: data.map((v, i) => i === selIdx ? accent : '#ffffff'),
          pointBorderColor: accent,
          pointRadius: data.map((v, i) => i === selIdx ? 5 : 2),
          pointHoverRadius: 6
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        elements: { line: { tension: 0.3 } },
        scales: {
          xAxes: [{ gridLines: { display: false }, ticks: { fontSize: 11, fontColor: '#9CA3AF', maxRotation: 0 } }],
          yAxes: [{
            gridLines: { color: 'rgba(0,0,0,0.04)' },
            ticks: { beginAtZero: true, fontSize: 11, fontColor: '#9CA3AF', callback(v) { return (v % 1 === 0) ? v : undefined; } }
          }]
        },
        tooltips: {
          backgroundColor: 'rgba(255,255,255,0.95)', titleFontColor: '#333', bodyFontColor: '#666',
          borderColor: '#e9ecef', borderWidth: 1, cornerRadius: 8, xPadding: 12, yPadding: 10,
          callbacks: { label(ti) { return ' 결제 ' + Number(ti.yLabel || 0).toLocaleString() + '건'; } }
        }
      }
    });
  };

  renderStatCard = (icon, color, label, value, sub) => (
    <div className="smo-stat-card">
      <div className="smo-stat-card__icon" style={{background: color.bg, color: color.fg}}>
        <FeatherIcon icon={icon} size="20"/>
      </div>
      <div className="smo-stat-card__body">
        <div className="smo-stat-card__label">{label}</div>
        <div className="smo-stat-card__value">{value}</div>
        {sub ? <div className="smo-stat-card__sub">{sub}</div> : null}
      </div>
    </div>
  );

  render() {
    const s = this.stats;
    const monthLabel = moment(this.selectedMonthStr, 'YYYY-MM').format('YYYY년 M월');
    const krw = n => '₩' + Number(n || 0).toLocaleString();
    const num = n => Number(n || 0).toLocaleString();

    function PaySuccess(props) {
      const map = {
        success: { txt: '결제완료', cls: 'is-success' },
        refund:  { txt: '환불', cls: 'is-refund' },
        fail:    { txt: '실패', cls: 'is-fail' },
        ing:     { txt: '결제중', cls: 'is-ing' }
      };
      const st = map[props.paySuccess] || { txt: props.paySuccess, cls: '' };
      return <span className={`smo-pay-badge ${st.cls}`}>{st.txt}</span>;
    }

    return (
      <div className="main-content smo-page">
        <PageTitle />

        {/* 월 선택 네비게이션 */}
        <div className="smo-month-nav">
          <button type="button" className="smo-month-nav__btn" onClick={() => this.changeMonth(-1)} title="이전 달">
            <FeatherIcon icon="chevron-left" size="18"/>
          </button>
          <span className="smo-month-nav__label">{monthLabel}</span>
          <button type="button"
                  className="smo-month-nav__btn"
                  onClick={() => this.changeMonth(1)}
                  disabled={this.isCurrentMonth()}
                  title="다음 달">
            <FeatherIcon icon="chevron-right" size="18"/>
          </button>
          {!this.isCurrentMonth() && (
            <Button size="sm" outline theme="secondary" className="smo-month-nav__today" onClick={() => this.setThisMonth()}>
              이번 달
            </Button>
          )}
          {this.isLoading && <span className="smo-month-nav__loading">불러오는 중…</span>}
        </div>

        {/* 통계 위젯 */}
        <div className="smo-stat-grid">
          {this.renderStatCard('credit-card', {bg:'#EEF2FF', fg:'#4A6CF7'}, '결제 금액', krw(s.revenue), monthLabel + ' 결제완료 합계')}
          {this.renderStatCard('shopping-cart', {bg:'#ECFDF5', fg:'#059669'}, '결제완료 건수', num(s.orderCount) + ' 건', monthLabel + ' 결제완료 주문')}
          {this.renderStatCard('message-square', {bg:'#FEF3C7', fg:'#B45309'}, '충전 메시지', num(s.chargeCount) + ' 건', '알리고 ' + num(Math.round(s.chargeCount * ALIGO_UNIT)) + 'P')}
        </div>

        {/* 월별 결제 건수 추이 (라인 차트) */}
        <div className="smo-chart-box">
          <div className="smo-chart-box__head">
            <h3>월별 결제 건수</h3>
            <span className="smo-chart-box__sub">최근 12개월 · 결제완료 기준</span>
          </div>
          <div className="smo-chart-box__canvas">
            <canvas ref={this.trendChartRef} />
          </div>
        </div>

        {/* 상세 결제 내역 */}
        <div className="section-box basic-info-table smo-table-box">
          <div className="smo-table-head">
            <h3>결제 내역 <span className="smo-table-head__month">{monthLabel}</span></h3>
            <span className="smo-table-head__count">총 {num(this.monthDocs.length)}건</span>
          </div>
          <table>
            <thead>
            <tr>
              <th>결제 id</th>
              <th>스토어</th>
              <th>잔여건</th>
              <th>발송건(전체)</th>
              <th>충전건</th>
              <th>결제 상품명</th>
              <th>결제 금액</th>
              <th>결제상태</th>
              <th>주문일</th>
              <th>payment</th>
            </tr>
            </thead>
            <tbody>
            {this.monthDocs && this.monthDocs.length > 0 ?
                this.monthDocs.map((item, i) => (
                    <tr key={i}>
                      <td>{item.platformOrderId}</td>
                      <td>{item.store_id ? item.store_id.name + "(" + item.store_id.platformId + ")" : ''}</td>
                      <td>{item.store_id ? item.store_id.messageQuota : null}</td>
                      <td>{item.store_id && this.history && this.history[item.store_id._id] ? this.history[item.store_id._id].count : 0}</td>
                      <td>{num(item.count)}</td>
                      <td>{item.orderName}</td>
                      <td>{krw(item.orderAmount)}</td>
                      <td><PaySuccess paySuccess={item.paySuccess} /></td>
                      <td>{item.createdAt ? moment(item.createdAt).format('YYYY-MM-DD HH:mm') : ''}</td>
                      <td>
                        {item.payment && item.payment.length > 0 ? item.payment.map((paymentItem, p) => (
                            <Badge theme="info" key={p}>{paymentItem.payment_status}</Badge>
                        )) : null}
                      </td>
                    </tr>
                ))
                : (
                    <tr>
                      <td colSpan="10" className="text-center smo-empty">
                        {this.isLoading ? '불러오는 중…' : monthLabel + ' 결제 내역이 없습니다.'}
                      </td>
                    </tr>)
            }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default StoreMsgOrderList;
